export default function onlyNumbers(text: string) {
  return text.replace(/[^0-9]/g, '');
}
